module.exports = __webpack_public_path__ + "static/media/19.512008c6.png";